'use client'

import { useState, useEffect } from 'react'
import { HtmlContentBlockFragment } from './HtmlContentBlock.generated'

type HtmlContentBlockProps = {
	fragment: HtmlContentBlockFragment
}

export default function HtmlContentBlock({ fragment }: HtmlContentBlockProps) {
	const [content, setContent] = useState('')
	const [anchor, setAnchor] = useState('')
	const [isMounted, setIsMounted] = useState(false)

	useEffect(() => {
		setContent(fragment.content)
		setAnchor(fragment.anchor)
		setIsMounted(true)
	}, [fragment.content, fragment.anchor])

	return (
		isMounted && (
			<div
				id={anchor ? 'spy_' + anchor.replaceAll(' ', '_') : ''}
				className="container-auto py-4 flex justify-center"
			>
				<div
					className="space-y-4 markdown"
					dangerouslySetInnerHTML={{
						__html: content,
					}}
					id={anchor}
				/>
			</div>
		)
	)
}
